module.exports = __webpack_public_path__ + "static/media/oval-mango.f1359b4d.svg";